import { render, staticRenderFns } from "./DistribucionSubTab.vue?vue&type=template&id=fa0a96fa&"
import script from "./DistribucionSubTab.vue?vue&type=script&lang=js&"
export * from "./DistribucionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports